import React from 'react'
import {
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@material-ui/core'
import clsx from 'clsx'
import useMobileStyle from 'app/components/mobileModal/mobileModalStyle'
import { FormattedMessage } from 'react-intl'
import CancelButton from 'app/components/buttons/CancelButton'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'

export default (props) => {
  const { state, classes, toggleDialogs, exportPDF, EXPORT_PDF_DIALOG } = props
  const mobileClasses = useMobileStyle()

  return (
    <ResponsiveDialog
      isFullScreen={false}
      open={state[EXPORT_PDF_DIALOG]}
      className={clsx(
        classes.groupDialog,
        classes.groupDialogStyleOne,
        mobileClasses.lessPaddingMobile,
      )}
    >
      <DialogTitle id="alert-dialog-title" className={classes.groupDeleteTitle}>
        <FormattedMessage id="groups.dialog.exportPDF.title" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <FormattedMessage id="groups.dialog.exportPDF.desc" />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <CancelButton
          onClick={() => {
            toggleDialogs(EXPORT_PDF_DIALOG, false)
          }}
          className={mobileClasses.modalBtn}
        />
        <Button
          color="primary"
          className={clsx(
            classes.actionBtn,
            classes.groupActionBtns,
            mobileClasses.modalBtn,
          )}
          variant="contained"
          onClick={exportPDF}
        >
          <FormattedMessage id="action.export" />
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  )
}
